module.exports = require('./helpers/bundle-url').getBundleURL('jbGzv') + "logo.c51670a8.svg";